// extracted by mini-css-extract-plugin
export default {"cardOrigem":"OrigemIndividualListagem_cardOrigem__oyhbe"};